export default {
	note_datefield_close: 'Schließen',
	note_delete_dialog_confirm_cancel_label: 'Nein',
	note_delete_dialog_confirm_message: 'Möchten Sie diesen Merkzettel wirklich löschen?',
	note_delete_dialog_confirm_ok_label: 'Ja',
	note_delete_dialog_confirm_title: 'Merkzettel löschen',
	note_fixed_description_label: 'Beschreibung',
	note_fixed_maturity_date_label: 'Datum',
	note_save_failed_notification: 'Merkzettel konnte nicht gespeichert werden',
	note_saved_notification: 'Merkzettel wurde gespeichert',
	note_version_author: 'Autor',
	note_version_dialog_cancel: 'Abbrechen',
	note_version_dialog_confirm_cancel_label: 'Nein',
	note_version_dialog_confirm_message: 'Möchten Sie diese Version wirklich löschen?',
	note_version_dialog_confirm_ok_label: 'Ja',
	note_version_dialog_confirm_title: 'Merkzettel-Version löschen',
	note_version_time: 'Datum',
	note_version_title: 'Titel',
	note_version_versions: 'Versionen',
};
